import styles from "./styles.module.scss";
import img1 from "./img/img1.png";
import img2 from "./img/img2.png";
import img3 from "./img/img3.png";
import img4 from "./img/img4.png";

import { IconCardWalky } from "src/routes/onboarding/shared/components/iconCardWalky";
import { WALKY_KEYS } from "src/routes/onboarding/shared/constants/walkyKeys";

const data = [
  {
    value: "9 to 5", // ?
    displayValue: "9 to 5",
    emoji: img1,
  },
  {
    value: "Night shifts",
    displayValue: "Night shifts",
    emoji: img2,
  },
  {
    value: "Flexible hours",
    displayValue: "Flexible hours",
    emoji: img3,
  },
  {
    value: "I'm retired/not working right now",
    displayValue: "I'm retired/not working right now",
    emoji: img4,
  },
];
export const WorkLifeLookLike = ({ onNextStep, onTrackEvent }) => {
  const handleNextStep = (v) => {
    localStorage.setItem(WALKY_KEYS.walkingSpendTime, v.points);
    onNextStep(v.value);
    onTrackEvent?.(v.displayValue);
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2>How does your work life look like?</h2>
        <div className={styles.cards}>
          {data.map((value) => (
            <IconCardWalky
              onClick={() => handleNextStep(value)}
              img={value.emoji}
              title={value.displayValue}
              key={value.points}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
